import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CommonService } from 'src/services/common/common.service';
import { ServiceManagerService } from 'src/services/service-manager.service';

@Component({
  selector: 'app-policy-terms',
  templateUrl: './policy-terms.component.html',
  styleUrls: ['./policy-terms.component.scss']
})
export class PolicyTermsComponent implements OnInit {

  content: any =''
  queryParams: any;
  selectedTab: any =  {
    index : 0
  }
  /**
   * Creates an instance of policy terms component.
   * @param route 
   * @param commonService 
   * @param serviceManager 
   */
  constructor(private route: ActivatedRoute,
    public commonService: CommonService,
    private serviceManager: ServiceManagerService) { 
      route.queryParams.subscribe((params: any) => {
        this.queryParams = params
        if(params['ispolicy'] === 'false'){
          this.selectedTab.index = 1
        }
        this.getContent(this.selectedTab)
      })
  }

  ngOnInit(): void {}

  /**
   * Gets content
   * @param event 
   */
  getContent(event: any){
    this.content = ''
    var service = !event.index ? 'privacy_policy' : 'terms_of_service'
    var body = {
      "is_policy": !event.index ,
      "user_type": 'User'
    }
    this.serviceManager.CallBackendServiceAPI(service, body).subscribe(
      (data : any) =>{
        this.content = decodeURIComponent(escape( atob(data?.response?.data)));
      },
      (error : any) => {
        console.log(error);  
      }
    )
  }
}
